const PREFIX = 'rooted:v1:';

// =====================================================================
// Generic helpers (kept for backwards compatibility with any callers)
// =====================================================================
export function save(key, value) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    /* ignore quota / serialization errors */
  }
}

export function load(key, fallback = null) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (raw == null) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function remove(key) {
  try {
    localStorage.removeItem(PREFIX + key);
  } catch {
    /* ignore */
  }
}

// =====================================================================
// Typed accessors used by AppContext + Welcome / StudyPlan screens
// =====================================================================
export function saveStudy(study) {
  try {
    localStorage.setItem(PREFIX + 'study', JSON.stringify(study));
  } catch (e) {
    console.warn('[Storage] Failed to save study:', e);
  }
}

export function loadStudy() {
  try {
    const data = localStorage.getItem(PREFIX + 'study');
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
}

export function saveUserProfile(profile) {
  try {
    localStorage.setItem(PREFIX + 'profile', JSON.stringify(profile));
  } catch {}
}

export function loadUserProfile() {
  try {
    const data = localStorage.getItem(PREFIX + 'profile');
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
}

export function saveGuide(guide) {
  try {
    localStorage.setItem(PREFIX + 'guide', JSON.stringify(guide));
  } catch {}
}

export function loadGuide() {
  try {
    const data = localStorage.getItem(PREFIX + 'guide');
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
}

export function saveDaysUnlocked(days) {
  try {
    localStorage.setItem(PREFIX + 'daysUnlocked', JSON.stringify(days));
  } catch {}
}

export function loadDaysUnlocked() {
  try {
    const data = localStorage.getItem(PREFIX + 'daysUnlocked');
    return data ? JSON.parse(data) : 1;
  } catch {
    return 1;
  }
}

// =====================================================================
// Clear-all (used by 'Start a new study' on StudyPlan)
// =====================================================================
export function clearAllData() {
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith(PREFIX))
      .forEach((k) => localStorage.removeItem(k));
  } catch {}
}

// Backwards-compat alias for older callers
export const clearAll = clearAllData;
